// extracted by mini-css-extract-plugin
export default {"container":"About_container__pxvGf","profilePicture":"About_profilePicture__+Kl3Q","infoList":"About_infoList__RLAz5"};